import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type {
  SalvarInstanciasDto,
  SalvarListIdGruposDto,
  SalvarWahaDto,
  TestarGrupoDto,
} from "@base/contracts";
import { useMonitoramentoGruposGateway } from "./monitoramento-grupos.contexto";

const chave = ["monitoramento-grupos"] as const;

export function useStatusMonitoramentoGrupos() {
  const gateway = useMonitoramentoGruposGateway();
  return useQuery({
    queryKey: [...chave, "status"],
    queryFn: () => gateway.obterStatus(),
  });
}

export function useInstanciasWaha(habilitado: boolean) {
  const gateway = useMonitoramentoGruposGateway();
  return useQuery({
    queryKey: [...chave, "instancias"],
    queryFn: () => gateway.listarInstancias(),
    enabled: habilitado,
  });
}

export function useGruposQualificados(habilitado: boolean) {
  const gateway = useMonitoramentoGruposGateway();
  return useQuery({
    queryKey: [...chave, "grupos"],
    queryFn: () => gateway.listarGrupos(),
    enabled: habilitado,
  });
}

export function useSalvarWaha() {
  const gateway = useMonitoramentoGruposGateway();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (corpo: SalvarWahaDto) => gateway.salvarWaha(corpo),
    onSuccess: () => void qc.invalidateQueries({ queryKey: [...chave] }),
  });
}

export function useSalvarListIdGrupos() {
  const gateway = useMonitoramentoGruposGateway();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (corpo: SalvarListIdGruposDto) => gateway.salvarListId(corpo),
    onSuccess: () => void qc.invalidateQueries({ queryKey: [...chave] }),
  });
}

export function useSalvarInstanciasWaha() {
  const gateway = useMonitoramentoGruposGateway();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (corpo: SalvarInstanciasDto) => gateway.salvarInstancias(corpo),
    onSuccess: () => void qc.invalidateQueries({ queryKey: [...chave] }),
  });
}

export function useTestarGrupoMonitoramento() {
  const gateway = useMonitoramentoGruposGateway();
  return useMutation({
    mutationFn: (corpo: TestarGrupoDto) => gateway.testarGrupo(corpo),
  });
}
